exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "button.btn-line {\n  border-top: 3px solid #566473;\n  border-bottom: 3px solid #566473;\n  padding: 8px 10px;\n  text-transform: uppercase;\n  background-color: transparent;\n  margin: 6px 10px;\n  border-left: none;\n  border-right: none;\n  cursor: pointer; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/layout/buttons/LineButton/index.scss
// module id = 973
// module chunks = 0